import script from "./Orario.vue?vue&type=script&setup=true&lang=js"
export * from "./Orario.vue?vue&type=script&setup=true&lang=js"

import "./Orario.vue?vue&type=style&index=0&id=66050f73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66050f73"]])

export default __exports__